// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5257":"53ff71a08b97646e874b","9585":"743385a47b2990479aed"}[chunkId] + ".js";
};